import Layer from 'components/Layer.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import React from 'react';
import Tooltip from 'components/Tooltip.jsx';
import Formsy from 'lib/Formsy';
import createChainedFunction from 'utils/createChainedFunction';
import doWhileMounted from 'utils/doWhileMounted';
import { isEqual } from 'lodash';
import cx from 'classnames';
import pickInputElementProps from 'utils/pickInputElementProps';
import focusNode from 'utils/focusNode';

import './styles/FormCellInput.scss';

const FormCellInput = React.createClass({
  propTypes: {
    name: React.PropTypes.string.isRequired,
    value: React.PropTypes.string,
    placeholder: React.PropTypes.string,
    warningMessage: React.PropTypes.string,
    validations: React.PropTypes.any,
    validationError: React.PropTypes.any,
    errorMessage: React.PropTypes.string,
    onChange: React.PropTypes.func,
    parsePasteWith: React.PropTypes.func,
    autofocus: React.PropTypes.bool,
  },

  mixins: [Formsy.Mixin],

  getInitialState() {
    return {
      focus: false,
      wasBlurred: false,
      value: this.props.value,
      wasJustMounted: true,
    };
  },

  componentWillMount() {
    if (this.props.value) {
      this.setValue(this.props.value); // To make the input not pristine
    }
  },

  componentDidMount() {
    if (this.props.autofocus) {
      // Prevents the cursor from being placed at the start of the text
      const node = this.refs.input;
      const value = node.value;
      node.value = '';
      focusNode(node);
      node.value = value;
    }
  },

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.changeValue(nextProps.value);
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    return !(isEqual(this.props, nextProps) && isEqual(this.state, nextState));
  },

  onFocus() {
    this.setState({ focus: true });
  },

  onBlur() {
    this.setState({ focus: false });
    if (this.state.wasBlurred === false) {
      this.setState({ wasBlurred: true });
    }
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  },

  onChange(event) {
    this.changeValue(event.currentTarget.value);
  },

  onPaste(e) {
    if (this.props.parsePasteWith) {
      e.stopPropagation();
      if (this.props.parsePasteWith(e)) {
        e.preventDefault();
      }
    }
  },

  changeValue(value) {
    this.setState({
      value,
      wasBlurred: false,
      wasJustMounted: false,
    });
  },

  /* This is for autofill purposes.
   * Some browsers does not emit change event when
   * they fill out the forms, so Formsy is not aware
   * the value change and the validation does not run.
   * This pulls the value from the DOM at
   * regular interval and if what is found is different
   * than what Formsy currently have then we tell Formsy
   * about this new value via the Formsy mixin.
   */
  lookForChanges() {
    if (!this.refs.input) {
      return;
    }

    const fieldVal = this.refs.input.value;
    if (fieldVal && this.getValue() !== fieldVal) {
      this.onChange({ currentTarget: { value: fieldVal } });
    }
  },

  render() {
    let errorMessage = this.getErrorMessage();

    const { value, onChange, warningMessage, ...others } = this.props;

    if (!value ||
      ((!this.state.wasBlurred && !this.state.wasJustMounted) || this.isPristine())) {
      errorMessage = null;
    }

    errorMessage = this.props.errorMessage || errorMessage;

    let tooltip = <Layer />;
    if (errorMessage) {
      tooltip = <Tooltip color="lava">{errorMessage}</Tooltip>;
    } else if (warningMessage) {
      tooltip = <Tooltip color="flame">{warningMessage}</Tooltip>;
    }

    const inputProps = pickInputElementProps(others);
    return (
      <LayerTrigger
        layer={tooltip}
        placement="bottom"
        alignment="left"
        trigger={['hover']}>
        <div
          className={cx('FormCellInput', {
            'FormCellInput--focus': this.state.focus,
            'FormCellInput--error': errorMessage,
            'FormCellInput--warning': warningMessage,
          })}>
          <input
            // MDN claims that onpaste is "non-standard and is not on a standards track" here:
            // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste
            // But the w3 working draft describing this behavior can be found here:
            // https://www.w3.org/TR/clipboard-apis/#the-paste-action
            // It appears to function as intended in Chrome, Firefox, Safari, and IE latest.
            onPaste={this.onPaste}
            {...inputProps}
            ref="input"
            value={this.state.value}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onChange={createChainedFunction(onChange, this.onChange)}
          />
        </div>
      </LayerTrigger>
    );
  },
});

export default doWhileMounted(FormCellInput, 'lookForChanges', 1000);



// WEBPACK FOOTER //
// ./src/components/FormCellInput.jsx